import { HI_STATUS_COLOR } from '../config/status';

export function getHIColourByStatus(status) {
  // TODO: Какой то магический статус, уже не помню в чем соль
  if (status === '-1' || status === undefined) {
    return HI_STATUS_COLOR[0];
  }
  return HI_STATUS_COLOR[status * 1];
}